import { StatusContainer } from "./style";

interface IProps {
  observacao: string | null | undefined;
  width?: string;
}
export function StatusPagamentoAguardando({ observacao, width }: IProps) {
  const observacoesPendencia = [
    "Custo divergente do cadastro do fornecedor",
    "Valor do custo incompatível com total da nota",
    "Possível duplicidade de pagamentos",
  ];

  const tipoObservacao =
    observacao && observacoesPendencia.some((obs) => observacao.includes(obs))
      ? "Aprovação manual"
      : "Correção solicitada";

  const handleStatus = () => {
    if (tipoObservacao === "Correção solicitada") {
      return {
        backgroundColor: "#FFE4E4",
        color: "#EE5353",
        border: "1px solid #EE5353",
      };
    }

    return {
      backgroundColor: "#FFEFCC",
      color: "#FF9F42",
      border: "1px solid #FF9F42",
    };
  };

  return (
    <StatusContainer width={width} style={handleStatus()}>
      {tipoObservacao}
    </StatusContainer>
  );
}
